import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import React from 'react';
import { Button, Nav } from 'react-bootstrap';
import ThemeControlDropdown from './ThemeControlDropdown';

const TopNavRightSideNavItem = () => {
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <Button
        className="mx-3"
        size="sm"
        variant="outline-warning"
        href="https://duckenergy-support.zendesk.com/hc/en-us"
        target="_blank"
      >
        Support
      </Button>

      <ThemeControlDropdown />
      {/* <NotificationDropdown /> */}
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
